export default __webpack_public_path__ + "static/media/result.88ae2721.svg";